// removed by extract-text-webpack-plugin
module.exports = {"spinner":"spinner__2N8t-","sk-bouncedelay":"sk-bouncedelay__RPfT2","bounce1":"bounce1__XTdQl","bounce2":"bounce2__366n-"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/spinner/spinner.css
// module id = TWzo
// module chunks = 323 333